import script from "./ActionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionCard.vue?vue&type=script&setup=true&lang=js"

import "./ActionCard.vue?vue&type=style&index=0&id=16c23e75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c23e75"]])

export default __exports__